export const BLADES = {
  getStarted: 'getStarted',
  yourDetails: 'yourDetails',
  accountDetails: 'accountDetails',
  completePage: 'complete',
};

export const STYLES = {
  headerHeight: 80,
};
